import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { REST_BASE_URL } from '../app.config';
import { VisumAntragZumSpeichern } from '../models/visum.antrag.zum.speichern';

@Injectable()
export class EncryptSignSaveService {

  constructor(private http: HttpClient) {
  }

  saveFile(antrag: VisumAntragZumSpeichern, language: string): Observable<any> {
    const params = new HttpParams().set('sprache', language);
    return this.http.post(REST_BASE_URL + '/mek-visum-antrag/encrypt-sign-save', antrag, { params });
  }
}
